// extracted by mini-css-extract-plugin
export default {"success":"gHius","btn":"_5V+VL"};